import SurveyCard from './SurveyCard';

export default SurveyCard;
